//#region IMPORTS
import LogoShort from '../../Assets/images/logo.png';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectVertical } from '../Filter/FiltersSlice';
import {
  ALGORITHMS,
  AZNODE_BACKGROUND,
} from '../../VerticalCards/VerticalCardsContainer';
import { useEffect } from 'react';
// CSS
import './Title.css';
//#endregion

// #region CONSTANTS
const BACKGROUND =
  'linear-gradient(to right, #ffbc42 ,#ffbc42 1%, #ffbd4265 1%, #00000000 90%)';
// #endregion

// #region COMPONENT
/**
 * @returns An awesome title
 */
const Title = props => {
  // #region INITIALIZATION
  // Properties
  const {
    label = null,
    showLines = true,
    showImage = true,
    capitalize = true,
  } = props;
  // #endregion

  const vertical = useSelector(selectVertical);

  useEffect(() => {
    if (vertical && vertical.name === ALGORITHMS.AZNODE) {
      document.documentElement.style.setProperty('--hover-color', '#ff4242ff');
      document.documentElement.style.setProperty('--active-color', '#ff4242ff');
      return;
    }

    document.documentElement.style.setProperty('--hover-color', '#ffbc42');
    document.documentElement.style.setProperty('--active-color', '#ffbc42');
  }, [vertical]);

  // #region INTERFACE
  return (
    <div className="Title-Container">
      {showLines && <div className="Separator-Left" />}
      <div
        className="Title-ImageTitreContainer"
        style={{
          background:
            vertical && vertical.name === ALGORITHMS.AZNODE
              ? AZNODE_BACKGROUND
              : BACKGROUND,
        }}
      >
        {showImage && (
          <img
            src={LogoShort}
            width={'auto'}
            height={40}
            className="Title-Image"
          />
        )}
        <h1 className={`Title ${capitalize ? 'Title-Capitalize' : ''}`}>
          {label}
        </h1>
      </div>
      {showLines && <div className="Separator-Right" />}
    </div>
  );
  // #endregion
};
// #endregion

export { Title };
